module.exports = __webpack_public_path__ + "images/DocuSign-4cd6b3.png";